module.exports = __webpack_public_path__ + "static/media/sport-weightlifter.9faa6860.vtt";